import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'formik';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import VehicleDetailsForm from './VehicleDetailsForm';
import VehicleMediaImageForm from './VehicleMediaImageForm';
import VehicleMediaVideoForm from './VehicleMediaVideoForm';
import VehicleTiresForm from './VehicleTiresForm';
import VehicleServiceHistoryForm from './VehicleServiceHistoryForm';
import VehicleFeaturesForm from './VehicleFeaturesForm';
import VehicleDamagesForm from './VehicleDamagesForm';
import VehicleDescriptionForm from './VehicleDescriptionForm';
import CommonLoader from '../../common/components/CommonLoader';
import ComponentCard from '../../common/components/cards/ComponentCard';
import { scrollToFirstError } from '../../common/helpers/scrollToFirstError';

function VehicleForm({ title, form }) {
  const basicData = useSelector((state) => state.vehicles.get('auctionDetails'));

  useEffect(() => {
    if (form?.submitCount > 0 && form?.errors && Object.keys(form.errors).length > 0) {
      scrollToFirstError();
    }
  }, [form?.submitCount, form?.errors]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {basicData ? (
        <ComponentCard title={title}>
          <Form autoComplete="off">
            <VehicleDetailsForm form={form} />
            <VehicleMediaImageForm form={form} auction={basicData} />
            <VehicleMediaVideoForm form={form} />
            <VehicleTiresForm />
            <VehicleServiceHistoryForm form={form} services={form.values.services} />
            <VehicleDamagesForm form={form} />
            <VehicleFeaturesForm
              feature={form.values.newFeature}
              form={form}
              values={form?.values}
            />
            <VehicleDescriptionForm form={form} auction={basicData} />
            <Row>
              <Col md="12">
                <Button className="rounded-pill mt-4 float-end btn-primary" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </ComponentCard>
      ) : (
        <CommonLoader />
      )}
    </>
  );
}

VehicleForm.propTypes = {
  title: PropTypes.string,
};
VehicleForm.defaultProps = {
  title: '',
};

export default VehicleForm;
